import React, { useCallback, useEffect } from "react";
import { ReactComponent as ApprovalsDone } from "../../../../img/approval_svgs/ApprovalsDone.svg";
import { IconContainer } from "./elements/IconContainer";
import { Text } from "../../../general/Text";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FlexContainer } from "../../../../containers/FlexContainer";
import { useAccount } from "wagmi";
import { ApprovalStore } from "../../../../store/approvals/ApprovalsStore";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { getAllowances } from "../../../../store/global/getAllowances";
import { OrderStatus } from "../../../../types/orderStatus";
import { APPROVALS_MODAL_CLOSE_TIMEOUT } from "./Approvals";
import { useTimedQuoteRefetch } from "../../../../hooks/useTimedQuoteRefetch";

const metamaskPanelHeight = 120;
const rowPanelHeight = 68;
const enableSpendingsSection = 61;
const headerHeight = 200;
export const ApprovalsDoneScreen: React.FC = () => {
  const { connector } = useAccount();
  const numTokens = ApprovalStore.useState(s => s.tokensByFlow.approve.length);
  const isEnableSpendinngApplicable = ApprovalStore.useState(s => s.requiredSignatures.length > 0);
  const isMetamask = connector?.name === "MetaMask";

  const getTotalHeight = useCallback(() => {
    const metaMaskHeight = isMetamask ? metamaskPanelHeight : 0;
    const enableSpendingsHeight = isEnableSpendinngApplicable ? enableSpendingsSection : 0;
    const gap = 14;
    const rowPanelHeightTotal = (rowPanelHeight + gap) * numTokens;
    const totalHeight = metaMaskHeight + rowPanelHeightTotal + enableSpendingsHeight + headerHeight;
    return totalHeight;
  }, [isEnableSpendinngApplicable, isMetamask, numTokens]);
  const { forceRefresh: forceRefreshQuote } = useTimedQuoteRefetch();

  const network = GlobalStore.useState(s => s.network);
  const getAddress = () => GlobalStore.getRawState().address;

  const { tokenLists } = ApprovalStore.useState(s => s);
  const tokenList = tokenLists?.[network.id];
  useEffect(() => {
    const doAsync = async () => {
      await getAllowances.run({ tokenList, address: getAddress() as `0x${string}` });
      await forceRefreshQuote();
    };
    const timer = setTimeout(() => {
      doAsync()
        .then(() => {
          GlobalStore.update(s => {
            s.orderStatus = OrderStatus.ENTRY;
          });
        })
        .catch(e => {
          console.error(e);
        });
    }, APPROVALS_MODAL_CLOSE_TIMEOUT);

    return () => clearTimeout(timer); // Cleanup the timer
  }, [forceRefreshQuote, tokenList]);
  return (
    <SplashScreenContainer
      css={css`
        height: ${getTotalHeight()}px;
      `}
    >
      <IconContainer>
        {/*The width of the icon does not correspond to the actual width of the path internally */}
        <ApprovalsDone width={110} />
      </IconContainer>
      <Text
        shouldScale={false}
        textStyle="Title"
        size="Mid"
        textCss={css`
          text-align: center;
          max-width: 250px;
        `}
      >
        Tokens approved. You are now ready to place your trade.
      </Text>
    </SplashScreenContainer>
  );
};

export const SplashScreenContainer = styled(FlexContainer)`
  flex-direction: column;
  justify-content: center;
  gap: 35px;
  height: 462px;
`;
